module.exports = __webpack_public_path__ + "img/img_prize_gongsi@2x.f56ff8c0.png";